<template>
    <div class="vx-row">
        <div class="vx-col aspect-video md:w-1/2 mb-6">

            <video-player v-if="loaded" ref="videoPlayer" class="vjs-custom-skin m-3" :options="playerOptions"
                @play="onPlayerPlay($event)" @loadeddata="onPlayerLoadeddata($event)" @ready="onPlayerReady($event)"
                @timeupdate="onPlayerTimeupdate($event)">
            </video-player>
            <br>
            <div class="mt-5" v-if="loaded">
                <vs-button @click="play" size="small">play</vs-button>
                {{ currentTime | toHHMMSS }}/{{ duration | toHHMMSS }}
                <!-- <vs-progress v-if="loaded" :percent="(currentTime / duration) * 100" color="primary">primary</vs-progress>   -->
                <vue-slider v-model="currentTime" :max="duration" @dragging="seekTo">
                    <template v-slot:tooltip="{ value }">
                        <div class="bg-dark pa-3 text-white">{{ value | toHHMMSS }}</div>
                    </template>
                </vue-slider>
            

            </div>

        </div>
        <div class="vx-col  md:w-1/2 mb-6">

            <vs-tabs>
                <vs-tab label="Filters" icon="content_cut">
                    <div class="con-tab-ejemplo">
                        <Filters v-if="duration != 0" :duration="duration" :movie="movie" :position="currentTime" />
                    </div>
                </vs-tab>
                <vs-tab label="Subtitles" icon="closed_caption">
                    <div class="con-tab-ejemplo m-5">
                        <Subtitles :movie="movie" />
                        <br>
                        <br>
                        <br>
                    </div>
                </vs-tab>
                <vs-tab label="Sync" icon="refresh">
                    <Sync :movie="movie" :videos="videos" />
                </vs-tab>

            </vs-tabs>
        </div>

    </div>
</template>
<script>
import Filters from './Filters.vue'
import Subtitles from './Subtitles.vue'
import Sync from './sync.vue'
export default {
    props: ['movie'],
    components: {
        Filters, Subtitles, Sync
    },
    data() {
        return {
            videos: [],
            duration: 0,
            currentTime: 0,
            buffered: 0,
            loaded: false,
            playerOptions: {
                fill: true,
                fluid: false,
                autoplay: true,
                controls: true,
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true
                },

                // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
            }
        }
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player;
        },
        subtitle() {
            var subtitle = this.movie.response.subtitles.filter((subtitle) => {
                return subtitle.extention == "vtt";
            });
            if (subtitle.length != 0) {
                return subtitle[0];
            } else {
                return this.movie.response.subtitles[0];
            }
        },
    },
    mounted() {
        this.play()

    },
    created() {
        this.fetchVideos();
        if (this.videos.length != 0) {
            this.play();
            // setTimeout(() => {
            //     this.play();
            // }, 1000);
        }


    },
    filters: {
        toHHMMSS(secs) {
            var sec_num = parseInt(secs, 10)
            var hours = Math.floor(sec_num / 3600)
            var minutes = Math.floor(sec_num / 60) % 60
            var seconds = sec_num % 60

            return [hours, minutes, seconds]
                .map(v => v < 10 ? "0" + v : v)
                .filter((v, i) => v !== "00" || i > 0)
                .join(":")
        }
    },
    methods: {
        seekTo(time, index) {
            this.player.currentTime(time);
        },
        fetchVideos() {
            this.axios
                .get(`${this.$apiUrl}/v2/movies/videos/${this.movie.response.id}`)
                .then((res) => {
                    this.videos = res.data;
                    this.loaded = true;

                });
        },
        play() {
            if (this.videos.length != 0) {
                var src = this.videos[0].filename;

                this.playVideo(src)

            }

        },

        onPlayerTimeupdate(event) {
            console.log(event)
            this.currentTime = event.currentTime()
            this.buffered = event.bufferedPercent()
        },

        onPlayerLoadeddata(event) {
            this.duration = event.duration() | 0;
            console.log(event)
            //this.loaded = true;

        },
        onPlayerPlay(player) {

            //this.max=this.player.duration;
        },
        onPlayerReady(player) {
            this.play();

        },
        playVideo: function (source) {

            const video = {
                //withCredentials: false,
                type: 'video/mp4',
                src: source
            }
            this.loaded = true;
            this.player
                .reset() // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
            this.player.src(video)
            // this.player.load()
            this.player.play()
            this.player.addRemoteTextTrack({
                kind: "subtitles",
                src: this.subtitle.file,
                srclang: "ar",
                label: this.subtitle.en_name,
                default: true,
            });

        }
    },
}
</script>
<style scoped>
/* .player {
    width: 100%;
    height: 800px; */
/* } */

.vjs-custom-skin {
    height: 60% !important;
}

.vjs-custom-skin /deep/ .video-js {
    width: 100%;
min-height:300px;
}
</style>